import { __decorate } from "tslib";
import { Mixins, Component, Watch } from 'vue-property-decorator';
import RouteParamsAppMixin from '@/helpers/vue_mixins/RouterParamsAppMixin';
import PageTitle from '@/components/v2/PageTitle.vue';
import TopReferralsQuery from '@/plugins/graphql/queries/v2/ecommerce/ecommerce-top-referrals-paginated.gql';
let TopReferralsIndex = class TopReferralsIndex extends Mixins(RouteParamsAppMixin) {
    constructor() {
        super(...arguments);
        this.topReferrals = [];
        this.totalCount = 0;
        this.rowsPerPage = 10;
        this.pageInfo = {
            endCursor: '',
            hasNextPage: false,
            hasPreviousPage: false,
            startCursor: '',
        };
        this.paginatorLoading = false;
        this.paginationConfig = {
            descending: true,
            rowsPerPage: 10,
            page: 1,
        };
    }
    get headers() {
        return [
            {
                text: 'REFERRAL NAME',
                class: 'font-weight-bold subheading grey lighten-3',
                value: 'name',
                align: 'left',
                sortable: false,
            },
            {
                text: 'CLICKS',
                class: 'font-weight-bold subheading grey lighten-3',
                value: 'clicks',
                align: 'right',
                sortable: false,
            },
        ];
    }
    get initialVariables() {
        return {
            appUuid: this.appUUID,
            last: null,
            first: this.rowsPerPage,
            beforeCursor: null,
            afterCursor: null,
        };
    }
    pageObserver(currentPage, prevPage) {
        if (currentPage > prevPage) {
            this.navigateNextCursor();
        }
        else {
            this.navigatePrevCursor();
        }
    }
    rowsPerPageObserver(newPerPage) {
        this.paginationConfig.page = 1;
        this.rowsPerPage = newPerPage;
    }
    navigatePrevCursor() {
        this.paginatorLoading = true;
        this.$apollo.queries.topReferrals.fetchMore({
            // New variables
            variables: {
                appUuid: this.appUUID,
                first: null,
                last: this.rowsPerPage,
                beforeCursor: this.pageInfo.startCursor,
            },
            // Transform the previous result with new data
            updateQuery: (previousResult, { fetchMoreResult }) => {
                const { ecommerceTopReferrals } = fetchMoreResult;
                this.paginatorLoading = false;
                return {
                    ecommerceTopReferrals: {
                        ...previousResult.ecommerceTopReferrals,
                        edges: ecommerceTopReferrals.edges,
                        pageInfo: ecommerceTopReferrals.pageInfo,
                    },
                };
            },
        });
    }
    navigateNextCursor() {
        this.paginatorLoading = true;
        this.$apollo.queries.topReferrals.fetchMore({
            // New variables
            variables: {
                appUuid: this.appUUID,
                first: this.rowsPerPage,
                last: null,
                afterCursor: this.pageInfo.endCursor,
            },
            // Transform the previous result with new data
            updateQuery: (previousResult, { fetchMoreResult }) => {
                const { ecommerceTopReferrals } = fetchMoreResult;
                this.paginatorLoading = false;
                return {
                    ecommerceTopReferrals: {
                        ...previousResult.ecommerceTopReferrals,
                        edges: ecommerceTopReferrals.edges,
                        pageInfo: ecommerceTopReferrals.pageInfo,
                    },
                };
            },
        });
    }
};
__decorate([
    Watch('paginationConfig.page')
], TopReferralsIndex.prototype, "pageObserver", null);
__decorate([
    Watch('paginationConfig.rowsPerPage')
], TopReferralsIndex.prototype, "rowsPerPageObserver", null);
TopReferralsIndex = __decorate([
    Component({
        components: {
            PageTitle,
        },
        apollo: {
            topReferrals: {
                query: TopReferralsQuery,
                variables() {
                    return this.initialVariables;
                },
                update({ ecommerceTopReferrals }) {
                    const { edges, pageInfo, totalCount } = ecommerceTopReferrals;
                    this.pageInfo = pageInfo;
                    this.totalCount = totalCount;
                    return edges.map(({ node }) => node);
                },
            },
        },
    })
], TopReferralsIndex);
export default TopReferralsIndex;
